import { Link } from "react-router-dom";
import { ArrowLeft, ScrollText } from "lucide-react";

/**
 * Phase 3.56 — Allgemeine Geschäftsbedingungen für twowheels.info.
 *
 * Feb-2026 (User-Wunsch 25 May, Update v5): inhaltlich auf den Marktplatz
 * mit Auktionen, B2B/B2C, Vermittler, KI-Tools, Premium-Tarifen erweitert.
 * Vor Live-Deployment durch anwaltlich geprüfte Endfassung ersetzen;
 * Struktur und Routen bleiben gleich.
 */
export default function AgbPage() {
    return (
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-10" data-testid="legal-agb-page">
            <Link to={-1} onClick={(e) => { e.preventDefault(); window.history.back(); }} className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-[#111827] mb-4">
                <ArrowLeft className="w-4 h-4" /> Zurück
            </Link>
            <div className="flex items-center gap-3 mb-6">
                <ScrollText className="w-7 h-7 text-[#FFCC00]" />
                <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Allgemeine Geschäftsbedingungen</h1>
            </div>
            <p className="text-sm text-gray-500 mb-8">Stand: Februar 2026 · twowheels.info — Marktplatz für Motorräder und Fahrräder</p>

            <article className="prose prose-sm max-w-none space-y-6 text-[#111827]">
                <section>
                    <h2 className="font-display text-xl font-bold mb-2">1. Geltungsbereich &amp; Vertragspartner</h2>
                    <p>
                        Diese Allgemeinen Geschäftsbedingungen (AGB) regeln das Nutzungsverhältnis zwischen
                        TwoWheels, Inhaber Jörg Scholz („Anbieter" / „Plattform") und ihren Nutzern: Privatkäufer und
                        Privatverkäufer (B2C / C2C), gewerblichen Händlern (B2B), Vermittlern, Clubs / Vereinen
                        sowie Dienstleistern und Herstellern. Mit der Registrierung erkennt der Nutzer die
                        Geltung dieser AGB in der jeweils aktuellen Fassung an.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">2. Leistungen der Plattform</h2>
                    <p>
                        twowheels.info stellt eine Online-Marktplatzinfrastruktur bereit, über die Nutzer
                        Motorräder und Fahrräder zum Festpreis-Kauf, zur Auktion, zum Tausch (Trade-In),
                        zur Vermietung („Sharing") oder zur Vermittlung anbieten können. Die Plattform ist
                        nicht Vertragspartei der zwischen den Nutzern abgeschlossenen Kaufverträge, sondern
                        agiert als technischer Vermittler.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">3. Registrierung &amp; Konto</h2>
                    <p>
                        Die Nutzung setzt eine Registrierung mit wahrheitsgemäßen Angaben voraus. Login per
                        E-Mail/Passwort sowie über Google-OAuth ist möglich. Der Nutzer ist für die
                        Geheimhaltung seines Passworts und für sämtliche Aktivitäten unter seinem Konto
                        verantwortlich. Mehrfachregistrierungen, Stellvertreter-Konten und Identitäts-
                        Vortäuschung sind untersagt und führen zur sofortigen Sperrung.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">4. Pflichten der Inserenten</h2>
                    <p>
                        Inserate müssen wahrheitsgemäß, vollständig und nicht irreführend sein. Insbesondere:
                    </p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>Marke, Modell, Erstzulassung, Laufleistung und bekannte Mängel müssen korrekt angegeben werden.</li>
                        <li>Bilder müssen aktuell sein und das tatsächliche Fahrzeug zeigen — Stock-Fotos sind unzulässig.</li>
                        <li>Gewerbliche Anbieter müssen Verbraucherschutz-Vorschriften (Widerruf, Gewährleistung) einhalten.</li>
                        <li>Doppel-Inserate desselben Fahrzeugs auf unterschiedlichen Konten sind unzulässig.</li>
                        <li>Bei TÜV / HU-Angaben gilt das tatsächliche Ablaufdatum laut Plakette / ZB1.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">5. Auktionen</h2>
                    <p>
                        Auktionen laufen mit fest definierter Laufzeit. Mit Abgabe eines Gebots gibt der Bieter
                        ein verbindliches Kaufangebot ab; bei Höchstgebot kommt der Kaufvertrag zustande,
                        sobald der Mindestpreis erreicht oder eine vorherige Mindestpreis-Abweichung vom
                        Inserenten freigegeben wird. Eine Rücknahme abgegebener Gebote ist nur in den vom
                        BGB vorgesehenen Ausnahmefällen möglich.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">6. Trade-In &amp; Sharing</h2>
                    <p>
                        Trade-In-Angebote (Inzahlungnahme) und Sharing-Vermietungen sind freiwillige
                        Zusatzmodule. Die Abwicklung erfolgt direkt zwischen den beteiligten Parteien;
                        Versicherungs- und Verkehrssicherheitsaspekte liegen vollständig in deren
                        Verantwortung.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">7. Vermittler-Provisionen</h2>
                    <p>
                        Vermittler erhalten eine plattformseitig hinterlegte Provision auf erfolgreich
                        vermittelte Käufe, sofern eine Kennung („Vermittler-Code") vor Vertragsschluss
                        durch den Käufer eingegeben wurde. Die Provision wird über das Plattform-Wallet
                        („€-Punkte") gutgeschrieben und kann monatlich ausgezahlt werden.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">8. Gebühren &amp; Premium-Funktionen</h2>
                    <p>
                        Basis-Inserate für Privatpersonen sind kostenfrei. Kostenpflichtig sind insbesondere:
                    </p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>Top-Listings / Premium-Platzierung</li>
                        <li>Auktions-Modul (Gebührentabelle im Dashboard)</li>
                        <li>Werbe-Banner und Social-Media-Kreuzposting</li>
                        <li>Auto-Sync zu externen Börsen (z. B. eBay)</li>
                        <li>B2B-Premium (CSV-Import, Massenbearbeitung, Warenwirtschafts-Anbindung)</li>
                    </ul>
                    <p>Die jeweils aktuellen Preise und Tarif-Stufen stehen im Profil / Dashboard.</p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">9. KI-Tools &amp; Datenverarbeitung</h2>
                    <p>
                        Die Plattform stellt KI-gestützte Hilfsfunktionen bereit (Foto-Analyse, Sprach-Zu-Inserat,
                        Dokumenten-Scan ZB1/COC, Pricing-Vorschlag, Plausibilitäts-Check, Schadens-Aggregation,
                        SEO-Metadaten, automatische Übersetzungen). Diese Funktionen sind UNVERBINDLICHE
                        Vorschläge — der Inserent bleibt für die finale Korrektheit aller Angaben verantwortlich.
                        Inhalte können zur Verbesserung der KI-Modelle anonymisiert weiterverarbeitet werden;
                        Details in der Datenschutzerklärung.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">10. Bilder, Videos &amp; Rechte Dritter</h2>
                    <p>
                        Der Nutzer versichert, alle Bild-, Video- und Textrechte an hochgeladenen Inhalten zu
                        besitzen oder eine entsprechende Lizenz vorweisen zu können. Mit dem Upload räumt der
                        Nutzer twowheels.info ein einfaches, weltweites, zeitlich begrenztes Nutzungsrecht zur
                        Anzeige im Rahmen der Marktplatzfunktionen ein. Persönlichkeitsrechte Dritter
                        (z. B. Gesichter, Kennzeichen) müssen vor Upload entfernt werden.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">11. Widerruf für Verbraucher</h2>
                    <p>
                        Beim Kauf kostenpflichtiger Premium-Funktionen durch Verbraucher gilt das gesetzliche
                        14-tägige Widerrufsrecht (§§ 312 g, 355 BGB). Die Widerrufsbelehrung ist Bestandteil
                        des jeweiligen Kaufprozesses. Bei sofort vollständig erbrachten digitalen Leistungen
                        kann auf das Widerrufsrecht verzichtet werden.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">12. Haftung</h2>
                    <p>
                        twowheels.info haftet unbeschränkt nur bei Vorsatz und grober Fahrlässigkeit. Bei einfacher
                        Fahrlässigkeit haftet die Plattform nur bei Verletzung wesentlicher Vertragspflichten
                        und begrenzt auf den typischen, vorhersehbaren Schaden. Für Schäden aus Verträgen,
                        die Nutzer untereinander schließen, übernimmt twowheels.info keine Haftung. Die Haftung
                        nach dem Produkthaftungsgesetz bleibt unberührt.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">13. Verstöße &amp; Konto-Sperrung</h2>
                    <p>
                        Bei Verstößen gegen diese AGB, gegen Gesetze oder bei begründetem Verdacht auf Betrug
                        behält sich twowheels.info das Recht vor, Inserate zu entfernen, Konten temporär oder
                        dauerhaft zu sperren und ggf. Schadensersatz zu fordern. Im Wiederholungsfall kann
                        die Plattform Anzeige bei den Strafverfolgungsbehörden erstatten.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">14. Kündigung</h2>
                    <p>
                        Der Nutzer kann sein Konto jederzeit über die Kontoeinstellungen oder per E-Mail an
                        <a href="mailto:support@twowheels.info" className="underline mx-1">support@twowheels.info</a>
                        schließen. Aktive Premium-Tarife laufen bis zum Ende der jeweiligen Abrechnungsperiode
                        weiter. Daten werden gemäß DSGVO und unserer Datenschutzerklärung gelöscht oder
                        anonymisiert.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">15. Änderungen der AGB</h2>
                    <p>
                        twowheels.info kann diese AGB mit Wirkung für die Zukunft anpassen. Nutzer werden mindestens
                        30 Tage vor Wirksamwerden per E-Mail oder per Dashboard-Benachrichtigung informiert.
                        Widerspricht der Nutzer nicht innerhalb dieser Frist, gelten die geänderten AGB als
                        angenommen; das Widerspruchsrecht und sein Konto-Kündigungsrecht bleiben unberührt.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-bold mb-2">16. Schlussbestimmungen</h2>
                    <p>
                        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                        Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Anbieters (Berlin).
                        Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen
                        Bestimmungen unberührt.
                    </p>
                </section>
            </article>
        </div>
    );
}
